module.exports = __webpack_public_path__ + "media/images/flags/tl-d7a617ae56cf8ba008870bf4f32a800e.svg";